export default __webpack_public_path__ + "static/media/5.2f57685c.png";